import { useState } from 'react'
import { CitPeriodPicker } from '../../../components/finance/tax-compliance/CitPeriodPicker'
import { CitPreviewCard } from '../../../components/finance/tax-compliance/CitPreviewCard'
import { CitSuccessStep } from '../../../components/finance/tax-compliance/CitSuccessStep'
import { CitHistoryTable } from '../../../components/finance/tax-compliance/CitHistoryTable'
import type { PageMeta } from '../../../lib/permissions/pageMeta'

export const pageMeta: PageMeta = {
  key: 'finance.tax_compliance.cit',
  label: 'CIT Accrual',
  module: 'Finance',
  section: 'Tax Compliance',
  description: 'Monthly CIT computation and journal posting',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'view',
    accountant: 'edit', cashier: 'none', viewer: 'view',
  },
}

type Step = 'period' | 'preview' | 'success'

const NOW = new Date()

export default function CitAccrualPage() {
  const [step, setStep] = useState<Step>('period')
  const [year, setYear] = useState<number>(NOW.getFullYear())
  const [month, setMonth] = useState<number>(NOW.getMonth() + 1)

  if (step === 'preview') {
    return (
      <CitPreviewCard
        year={year}
        month={month}
        onBack={() => setStep('period')}
        onPosted={() => setStep('success')}
      />
    )
  }

  if (step === 'success') {
    return (
      <CitSuccessStep
        year={year}
        month={month}
        onRunAnother={() => setStep('period')}
      />
    )
  }

  return (
    <div className="space-y-8">
      <CitPeriodPicker
        year={year}
        month={month}
        onYearChange={setYear}
        onMonthChange={setMonth}
        onContinue={() => setStep('preview')}
      />
      <CitHistoryTable />
    </div>
  )
}
